module.exports = __webpack_public_path__ + "img/gogeography.846d6850.png";